import { initialState, LocationState } from "./state";
import { Actions } from './actions';
import { DELETE_LOCATION_RESPONSE, LOCATION_LIST, SAVE_LOCATION_RESPONSE } from "./actionTypes";

export function LocationReducer(state = initialState, action: Actions): LocationState {
    switch (action.type) {
        case LOCATION_LIST:
            return Object.assign({}, state, {
                locationList: action.payload
            });
        case SAVE_LOCATION_RESPONSE:
            return Object.assign({}, state, {
                saveLocationResponse: action.payload
            });
        case DELETE_LOCATION_RESPONSE:
            return Object.assign({}, state, {
                deleteLocationResponse: action.payload
            });
        default:
            return state;
    }
}
